export const dataArr = {
  acknowledged: true,
  projects: [
    {
      _id: '64d74484ed69bfee965e025d',
      title: 'Weather App',
      img: 'weatherapp.svg',
      body: 'Weather App built with React.js, offering real-time forecasts and user-friendly navigation. Using the free Open-Meteo Weather API for weather data, with seamless location access and user preferences management.',
      app_url: 'https://stormstina-react-weather-app.netlify.app/',
      code_url: 'https://github.com/stormstina/weather-app',
      blur_hash: 'A3EXq#kBPqWA',
      // blur_hash: 'L2AWr8Z~4T%0.RrpH?wa?tv|~p$y',
      languages: ['react', 'typescript', 'api', 'html', 'css', 'sass'],
    },

    {
      _id: '64d74552ed69bfee965e025e',
      title: 'Booking system',
      img: 'laundry.svg',
      body: 'The application offers user registration(with hashed passwords), login, and the making and canceling of one-time bookings. Expired bookings are automatically removed from the system. I started working out a solution using an already existing list MongoDB database with a REST API, but after learning node.js I have migrated it to my own backend solution.',
      app_url: 'https://github.com/stormstina/laundry-room-booking-system',
      // app_url:
      //   'https://laundry-room-booking-system-de2d4ba71aff.herokuapp.com/',
      code_url: 'https://github.com/stormstina/laundry-room-booking-system',
      blur_hash: 'S3Dvf@b6V=oaonoZD+j^',
      languages: [
        'mongodb',
        'node.js',
        'api',
        'express.js',
        'javascript',
        'html',
        'css',
        'sass',
      ],
    },
    {
      _id: '64d74484ed69bfee965e027d',
      title: 'E-Wallet',
      img: 'e-wallet.svg',
      blur_hash: 'SJNA-qes?[a$8wot-Wj?',

      body: "A credit card management app assignement. When launching the application, it initiates by retrieving a random user profile from the random user API and a credit card is generated and registered under the fetched user's name. This individual is designated as the primary account holder for all subsequently issued cards.",
      app_url: 'https://mellow-cobbler-4c4f66.netlify.app/',
      code_url: 'https://github.com/stormstina/e-wallet',
      languages: ['react', 'redux', 'tailwind', 'html', 'api'],
    },
    {
      _id: '64d74484ed69bfee965e027d',
      title: 'Character directory',
      img: 'rick-morty.svg',
      blur_hash: 'J2G8_,yZ00VX00iu',

      body: "A simple react web application that use the Rick and Morty API to showcase characters from the show. Users can search for characters by name and apply filters for gender, species and status. Dynamic pagination for easy navigation. It's styled using Tailwind CSS.",
      app_url: 'https://stormstina-rick-and-morty.netlify.app/',
      code_url: 'https://github.com/stormstina/rick-and-morty',
      languages: ['react', 'tailwind', 'api', 'html'],
    },

    {
      _id: '64d74484ed69bfee965e098d',
      title: 'Todo app',
      img: 'todo.svg',
      blur_hash: 'A7PjDUoz_NoJ',

      body: 'A simple React Todo App that lets users manage tasks. The app comes with functionalities to add new todos, edit existing ones, and delete tasks. Tailwind CSS is used for UI.',
      app_url: 'https://stormstina-todo-list.netlify.app/',
      code_url: 'https://github.com/stormstina/todo-list',
      languages: ['react', 'tailwind', 'html', 'local storage'],
    },
    {
      _id: '64d7456bed69bfee965e025f',
      title: 'Bank application',
      img: 'bank.svg',
      blur_hash: 'S0ODnI4n00%M00?b004n',

      body: 'Single-Page App (SPA) with client-side routing using vanilla JS classes. Server-side powered by Node.js, Express.js, and MongoDB for user registration(with hashed passwords), account creation, and banking operations.',
      app_url: 'https://github.com/stormstina/mongoDB-bank',
      // app_url: 'https://express-bank.herokuapp.com/',
      code_url: 'https://github.com/stormstina/mongoDB-bank',
      languages: [
        'mongodb',
        'node.js',
        'api',
        'express.js',
        'javascript',
        'html',
        'css',
        'sass',
      ],
    },
    {
      _id: '64d7456bed69bfee965e025g',
      title: 'Star-Wars Trivia',
      img: 'star-wars.svg',
      blur_hash: 'A5G+gnkW_Mof',

      body: 'An object oriented assignment that allows users to compare Star Wars characters and their respective characteristics using the free SWAPI-API. The application features a loading animation when the characters are first fetched (using Promise.all) and rendered to the DOM, and a different one for when a user clicks one of the action buttons.',
      app_url: 'https://stormstina.github.io/star-wars-trivia/',
      code_url: 'https://github.com/stormstina/star-wars-trivia',
      languages: ['api', 'javascript', 'html', 'css', 'sass', 'bootstrap'],
    },
    {
      _id: '64d7456bed69bfee965e025h',
      title: 'Tamagotchi',
      img: 'tamagotchi.svg',
      blur_hash: 'ABP?:ij]~qjt',

      body: "A 'Tamagotchi' virtual pet simulation project utilizing object-oriented programming. It incorporates attributes like name, animal type, and different needs. Buttons initiate actions like play, eat, and nap. Needs decrease over time, and status checks are performed. The interface includes a needs progress bar, action buttons, and result messages. If a need drops to zero, the pet dies, prompting a user restart.",
      app_url: 'https://stormstina.github.io/tamagotchi/',
      code_url: 'https://github.com/stormstina/tamagotchi',
      languages: ['javascript', 'html', 'css', 'sass'],
    },
    {
      _id: '64d7456bed69bfee965e025i',
      title: 'Shopping List',
      img: 'lists.svg',
      blur_hash: 'J0N^oDtS00M{00e-',

      body: 'In an agile group project, we served as clients/designers for a weather app and developers for a shopping list app. The shopping list offered a fixed product range like ICA/Coop, utilizing dynamic programming, Local Storage, JSON, APIs, and asynchronous code. The app is mobile-first, desktop-friendly, with Local Storage mimicking login and enabling list storage.',
      app_url: 'https://stormstina.github.io/my-lists/index.html',
      code_url: 'https://github.com/stormstina/my-lists',
      languages: [
        'api',
        'local storage',
        'javascript',
        'html',
        'css',
        'sass',
        'bootstrap',
      ],
    },
  ],
}
